var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.516,
    height: 22,
    viewBox: "0 0 30.516 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".filled{fill:var(--smd-primary);}.white-border{stroke:#ceedef;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "filled",
    d: "M11.316,1.5C5.076,1.5,0,6.069,0,11.684a9.415,9.415,0,0,0,1.8,5.508c-.223,2.466-.82,4.3-1.688,5.163A.377.377,0,0,0,.377,23,.359.359,0,0,0,.43,23,20.163,20.163,0,0,0,6.7,20.983a12.28,12.28,0,0,0,4.618.886c6.239,0,11.316-4.569,11.316-10.184S17.555,1.5,11.316,1.5Z",
    transform: "translate(0 -1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "filled white-border",
    d: "M9.625,1.5c5.307,0,9.625,3.886,9.625,8.662a8.009,8.009,0,0,1-1.53,4.685c.19,2.1.7,3.654,1.436,4.392a.321.321,0,0,1-.227.548.305.305,0,0,1-.045,0,17.151,17.151,0,0,1-5.331-1.713,10.446,10.446,0,0,1-3.928.753C4.318,18.825,0,14.939,0,10.162S4.318,1.5,9.625,1.5Z",
    transform: "translate(10.75 -1.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatDouble);
export default __webpack_public_path__ + "static/media/chat-double.00e376daebf9a3b72045a3d4e9ca3df2.svg";
export { ForwardRef as ReactComponent };